// src/pages/Home.js
import React from 'react';
import Logout from '../Authentication/Logout.js'; 
function Home() {
  return (
    <div>
        <Logout/>
    </div>
  );
}

export default Home;